import React, { useState } from "react";
import BackgroundEnquiry from "../images/bg_2.jpeg";
import ContactModalComponent from "./ContactModalComponent";

const EnquiryComponent = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <section className="ftco-intro ftco-section ftco-no-pt">
        <div className="container">
          <div className="row justify-content-center mt-5">
            <div className="col-md-12 text-center">
              <div
                className="img"
                style={{
                  backgroundImage: `url(${BackgroundEnquiry})`,
                }}
              >
                <div className="overlay"></div>
                <h2>We Are Pacific A Travel Agency</h2>
                <p>
                  We can manage your dream building A small river named Duden
                  flows by their place
                </p>
                <p className="mb-0">
                  <button
                    type="button"
                    // data-bs-toggle="modal"
                    // data-bs-target="#exampleModal"
                    className="btn btn-primary px-4 py-3"
                    onClick={() => setOpen(true)}
                  >
                    Ask For A Quote
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {open && <ContactModalComponent open={open} setOpen={setOpen} />}
    </>
  );
};

export default EnquiryComponent;
